export const environment = {
  production: false,
  env: 'qa' as const,
  appUrl: 'https://qa.videokestar.com',
  apiUrl: 'https://api-qa.videokestar.com/graphql',
  wsUrl: 'wss://api-qa.videokestar.com/graphql',
  googleClientId: '1019156695866-a2nesibgq0jt509sf7sfovnhq3eakhnq.apps.googleusercontent.com',
};
